import React from 'react';

function TileGroup(props) {
  const origClasses = props.className ? props.className : "";
  const scnd = props.scndKey ? " mdc-calc-key-group__secondary" : "";
  const classes = "mdc-calc-key-group" + scnd + origClasses;

  return (
    <div className={classes}>
      {props.children}
    </div>
  );
}

export default TileGroup;



// WEBPACK FOOTER //
// ./src/MDCCalc/TileGroup.js